import request from '@/util/request';
import qs from 'qs';
// export const getDictData = (params, options) =>
//     request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));


// export const putFile = (data, options) =>
//     request.post('/api/blade-resource/oss/endpoint/put-file', data, options);

//工单统计数据接口
export const getStatistic = (params, options) =>
    request.get('/api/v4ward/order/statistic', Object.assign({}, options, { params }));

//首页通知列表信息（通知列表接口）
export const getNotice = (params, options) =>
    request.get('/api/v4ward/notice/page', Object.assign({}, options, { params }));

//工单处理统计
export const getOrderStatistic = (params, options) =>
    request.get('/api/v4ward/order/handle/statistic', Object.assign({}, options, { params }));


// 获取列表
export const getProjectList = (params, options) =>
    request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));


// 获取列表-已弃用
export const isGroupView = (params, options) =>
    request.get('/api/v4ward/homepage/isGroupView', Object.assign({}, options, { params }));

// 判断用户类型
export const getUserType = (params, options) =>
    request.get('/api/v4ward/homepage/getUserType', Object.assign({}, options, { params }));

    
// 获取列表
export const getOrderTrend = (params, options) =>
    request.get('/api/v4ward/homepage/getOrderTrend', Object.assign({}, options, { params }));  
    
// 设备统计
// projectId
export const getDeviceTotal = (params, options) =>
request.get('/api/v4ward/homepage/getDeviceTotal', Object.assign({}, options, { params }));  
// 设备状态统计
// projectId
// status:1-异常,2-维保中,3-维修中,4-报废
export const getDeviceStatistics = (params, options) =>
request.get('/api/v4ward/homepage/getDeviceStatistics', Object.assign({}, options, { params })); 
// 价值分析
export const getValue = (params, options) =>
request.get('/api/v4ward/homepage/getValue', Object.assign({}, options, { params })); 

// 获取列表
// request.get('/api/v4ward/homepage/getOrderTrend', Object.assign({}, options, { params })); 

export const getOrderStatusCount = (params, options) =>
    request.get('/api/v4ward/homepage/getOrderStatusCount', Object.assign({}, options, { params })); 

// 获取工单类型统计
export const getOrderTypeCount = (params, options) =>
    request.get('/api/v4ward/homepage/getOrderTypeCount', Object.assign({}, options, { params })); 

// 获取付款合同类型统计
export const getContractPayCount = (params, options) =>
    request.get('/api/v4ward/homepage/getContractPayCount', Object.assign({}, options, { params })); 
    

// 获取收款合同类型统计
export const getContractIncomeCount = (params, options) =>
    request.get('/api/v4ward/homepage/getContractIncomeCount', Object.assign({}, options, { params })); 

// 获取收款合同类型统计
export const getExamineTrendScore = (params, options) =>
    request.get('/api/v4ward/homepage/getExamineTrendScore', Object.assign({}, options, { params })); 

// 获取收款合同类型统计
export const getQuestionnaireTrendScore = (params, options) =>
    request.get('/api/v4ward/homepage/getQuestionnaireTrendScore', Object.assign({}, options, { params })); 

// 获取表格配置
export const getPersonalConfig = (params, options) =>
    request.get('/api/v4ward/personal/config/table/getPersonalConfig', Object.assign({}, options, { params })); 

// 保存表格个性化配置
export const tableSubmitConfig = (params, options) =>
    request.post('/api/v4ward/personal/config/table/submit', params, options);

// 恢复表格默认配置
export const tableInitializeConfig = (params, options) =>
    request.post('/api/v4ward/personal/config/table/initialize', qs.stringify(params), options);

// 获取个人模版列表
export const getListByModuleType = (params, options) =>
    request.get('/api/v4ward/personal/config/export/getListByModuleType', Object.assign({}, options, { params })); 

// 获取全集字段集合
export const getListByModuleTypeAll = (params, options) =>
    request.get('/api/v4ward/personal/config/export/default/getListByModuleType', Object.assign({}, options, { params })); 

// 导出模板数据excel
export const getSupplierExportExcel = (params, options) =>
    request.get('/api/v4ward/personal/config/export/default/supplierExport', Object.assign({}, options, { params }));

// 保存个人导出模板
export const saveExportDataModulType = (params, options) =>
    request.post('/api/v4ward/personal/config/export/submit', params, options); 
    
// 删除个人导出模板
export const removeExportDataModulType = (params, options) =>
    request.post('/api/v4ward/personal/config/export/remove', qs.stringify(params), options);
